// @flow
import React, { useState } from "react";
import PageContainer from "../containers/PageContainer";
import ProductGroupsList from "../containers/ProductGroupsList";
import Pager from "../containers/Pager";
import { useTranslation } from 'react-i18next';


export default function ProductsView() {
    const { t } = useTranslation();

  return (
      <PageContainer title={t("Products Categories")} showShopToolbar={false}>
          <ProductGroupsList showAds={false} />
          <Pager />
        
    </PageContainer>
  );
}
